import { render, staticRenderFns } from "./marketCard.vue?vue&type=template&id=0138d835&scoped=true&"
import script from "./marketCard.vue?vue&type=script&lang=js&"
export * from "./marketCard.vue?vue&type=script&lang=js&"
import style0 from "./marketCard.vue?vue&type=style&index=0&id=0138d835&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138d835",
  null
  
)

export default component.exports